import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SchoolServiceData } from '../models/school-service-data.model';
import { SchoolServiceAdd } from '../models/school-service-add.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolServiceService {

  private apiUrl = `${environment.sgcApi}`;
  private engagementRoute = 'engagement';

  constructor(
    private httpClient: HttpClient
  ) {}

  createSchoolService(schoolService: SchoolServiceAdd, user: string) {
    let endpoint = `${this.apiUrl}${this.engagementRoute}/user/${user}/school`;
    return  this.httpClient.post<any>(endpoint, schoolService).pipe(
      map(data => data)
    );
  }

  updateSchoolService(schoolService: SchoolServiceData, user: string) {
    let endpoint = `${this.apiUrl}${this.engagementRoute}/user/${user}/school`;
    return  this.httpClient.put<any>(endpoint, schoolService).pipe(
      map(data => data)
    );
  }
}
